/* ===========================================================
   Myoform — Pricing Offer V2 carousel
   Crossfades the product slides. Autoplay pauses on hover, on
   focus, while the section is off screen, and once a visitor
   drives the carousel themselves.
   =========================================================== */

(function () {
  var instances = [];

  function Carousel(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-mpo-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-mpo-slide-dot]'));
    this.prev = root.querySelector('[data-mpo-prev]');
    this.next = root.querySelector('[data-mpo-next]');
    this.index = 0;
    this.timer = null;
    this.visible = true;
    this.hovered = false;
    this.stopped = false;

    var interval = parseInt(root.getAttribute('data-mpo-interval'), 10);
    this.interval = isNaN(interval) || interval < 1000 ? 5000 : interval;

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = root.getAttribute('data-mpo-autoplay') === 'true' && !reduced;
  }

  Carousel.prototype.goTo = function (index) {
    if (!this.slides.length) return;
    var count = this.slides.length;
    this.index = ((index % count) + count) % count;

    for (var i = 0; i < count; i++) {
      var active = i === this.index;
      this.slides[i].classList.toggle('is-active', active);
      if (active) {
        this.slides[i].removeAttribute('aria-hidden');
      } else {
        this.slides[i].setAttribute('aria-hidden', 'true');
      }
      if (this.dots[i]) {
        this.dots[i].classList.toggle('is-active', active);
        this.dots[i].setAttribute('aria-selected', active ? 'true' : 'false');
      }
    }
  };

  Carousel.prototype.play = function () {
    this.stop();
    if (!this.autoplay || this.stopped || this.hovered || !this.visible) return;
    if (this.slides.length < 2) return;
    var self = this;
    this.timer = window.setInterval(function () {
      self.goTo(self.index + 1);
    }, this.interval);
  };

  Carousel.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  Carousel.prototype.takeOver = function (index) {
    this.stopped = true;
    this.stop();
    this.goTo(index);
  };

  Carousel.prototype.bind = function () {
    var self = this;

    if (this.prev) {
      this.prev.addEventListener('click', function () {
        self.takeOver(self.index - 1);
      });
    }

    if (this.next) {
      this.next.addEventListener('click', function () {
        self.takeOver(self.index + 1);
      });
    }

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self.takeOver(i);
      });
    });

    this.root.addEventListener('mouseenter', function () {
      self.hovered = true;
      self.stop();
    });

    this.root.addEventListener('mouseleave', function () {
      self.hovered = false;
      self.play();
    });

    this.root.addEventListener('focusin', function () {
      self.hovered = true;
      self.stop();
    });

    this.root.addEventListener('focusout', function () {
      if (self.root.contains(document.activeElement)) return;
      self.hovered = false;
      self.play();
    });

    this.root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.takeOver(self.index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.takeOver(self.index + 1);
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        if (self.visible) {
          self.play();
        } else {
          self.stop();
        }
      });
      observer.observe(this.root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self.stop();
      } else {
        self.play();
      }
    });

    this.play();
  };

  function init(root) {
    if (root.dataset.mpoCarouselReady === 'true') return;
    root.dataset.mpoCarouselReady = 'true';

    var carousel = new Carousel(root);
    if (carousel.slides.length < 2) return;
    carousel.bind();
    instances.push(carousel);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-mpo-carousel]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    instances = instances.filter(function (item) {
      if (document.body.contains(item.root)) return true;
      item.stop();
      return false;
    });
    initAll(event.target);
  });

  /* Theme editor: selecting a slide block should show that slide. */
  document.addEventListener('shopify:block:select', function (event) {
    var node = event.target.closest
      ? event.target.closest('[data-mpo-slide]')
      : null;
    if (!node) return;
    for (var i = 0; i < instances.length; i++) {
      var at = instances[i].slides.indexOf(node);
      if (at > -1) {
        instances[i].takeOver(at);
        return;
      }
    }
  });
})();
